import { Button, Flex, Result, Typography } from "antd";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";

import { pathsSchema } from "shell/api/config";

import s from "./RouteErrorBoundary.module.css";

const { Text } = Typography;

export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  const handleNavigateToHome = () => {
    navigate(pathsSchema.index);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  let title = "Something went wrong";
  let description =
    "An unexpected error occurred. Please try refreshing the page.";
  const status: "error" | "500" = "error";

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = "Page not found";
      description = "The page you're looking for doesn't exist.";
    } else if (error.status === 403) {
      title = "Access denied";
      description = "You don't have permission to access this page.";
    } else {
      title = `Error ${error.status}`;
      description = error.statusText || description;
    }
  }

  return (
    <Flex
      align="center"
      justify="center"
      className={s.container}
      data-testid="route-error-boundary"
    >
      <Result
        status={status}
        title={title}
        subTitle={description}
        extra={
          <Flex gap="small">
            <Button type="primary" onClick={handleRefresh}>
              Refresh page
            </Button>
            <Button onClick={handleNavigateToHome}>Go to home</Button>
          </Flex>
        }
      >
        {import.meta.env.DEV && error instanceof Error && (
          <Flex vertical className={s.errorDetails}>
            <Text type="secondary" strong>
              Error details (development only):
            </Text>
            <Text type="secondary" code className={s.errorMessage}>
              {error.message}
            </Text>
          </Flex>
        )}
      </Result>
    </Flex>
  );
};
